<template>
  <div class="contactUs-box transition">
    <img
      src="https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/png/ABFWZMNH01234567_1593683748.png"
      class="contactUs-img banCopy"
    />

    <div class="contactUs-content-box transition">
      <div
        class="contactUs-top-box transition"
        v-for="(item, index) in hkjt.slice(0, 1)"
        :key="index"
      >
        <div class="contactUs-content-img-box banCopy">
          <img :src="item.img_url" class="contactUs-content-img" />
        </div>
        <ul class="contactUs-content-text-list list-unstyled transition">
          <li class="contactUs-content-title">
            <h4>{{ item.company }}</h4>
          </li>
          <li class="contactUs-content-text">
            {{ item.content }}
          </li>
          <li class="contactUs-content-text">
            <ul class="list-unstyled contentUs-content-details-list">
              <li>
                <span class="contentUs-content-details-title">地址</span>:
                {{ item.address }}
              </li>
              <li>
                <span class="contentUs-content-details-title">邮编</span>:
                {{ item.zip_code }}
              </li>
              <li>
                <span class="contentUs-content-details-title">电话</span>:
                {{ item.telephone }}
              </li>
              <li>
                <span class="contentUs-content-details-title">电子邮箱</span>:
                {{ item.email }}
              </li>
              <li>
                <span class="contentUs-content-details-title">传真</span>:
                {{ item.fax }}
              </li>
              <li>
                <span class="contentUs-content-details-title">公司网址</span>:
                {{ item.website }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="contentUs-map-box transition banCopy" id="mapContent">
        <!-- <img src="../image/c6111fd.png" class="contentUs-map-img transition"> -->
        <div></div>
      </div>

      <div class="contentUs-company-box transition">
        <ul class="contentUs-company-list list-unstyled">
          <li
            class="contentUs-company-item transition"
            v-for="(item, index) in hkjt.slice(1, 999)"
            :key="index"
          >
            <div class="contentUs-company-img-box banCopy">
              <img :src="item.img_url" class="contentUs-company-img" />
            </div>
            <div class="contentUs-company-content-body-box">
              <div class="contentUs-company-content">
                <h4 class="contentUs-company-name">{{ item.company }}</h4>
                <ul class="col-12 col-lg-10 list-unstyled">
                  <li class="list-address">地址：{{ item.address }}</li>
                  <li>电话：{{ item.telephone }}</li>
                  <li>传真：{{ item.fax }}</li>
                  <li>邮编：{{ item.zip_code }}</li>
                  <li>邮箱：{{ item.email }}</li>
                </ul>
              </div>
              <div class="contentUs-company-link-box banCopy">
                <a
                  class="contentUs-company-link"
                  :href="item.website"
                  target="_blank"
                  >前往官网</a
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { shallowRef } from "@vue/reactivity";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  setup() {
    const map = shallowRef(null);
    return {
      map,
    };
  },
  data() {
    return {
      hkjt: [],
      String: [],
      zoom: 15,
      timer: false,
      screenWidth: document.body.clientWidth,
      map: "",
    };
  },
  mounted() {
    document.title="杭开集团-联系我们";

    this.Post();

    const _this = this;
    // 画echars
    // 监听浏览器窗口变化
    window.addEventListener("resize", () => {
      this.screenWidth = document.body.clientWidth;
    });
    if (document.body.clientWidth <= 540) {
      this.zoom = 17;
    }
    this.initMap();
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.timer) {
          this.screenWidth = newVal;
          this.timer = true;
          let _this = this;
          setTimeout(() => {
            //在这里做有关浏览器变化时需要做的操作
            _this.timer = false;
          }, 400);
        }
        this.mapStyle();
      },
    },
  },
  methods: {
    mapStyle() {
      //   #mapContent    .contentUs-map-box
      if (this.screenWidth <= 540) {
      } else {
      }
    },
    initMap() {
      setTimeout(() => {
        AMapLoader.load({
          key: "335ea0bd1b195ba1b9909dc5c5dffe6d", // 申请好的Web端开发者Key，首次调用 load 时必填
          plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
          .then((AMap) => {
            var map = new AMap.Map("mapContent", {
              //设置地图容器id
              zoom: this.zoom, //初始化地图级别
              //center: [120.159409, 30.37091], //初始化地图中心点位置 老园区
              center: [120.021808,30.286848], //初始化地图中心点位置
              resizeEnable: true,
              rotateEnable: true,
              pitchEnable: true,
              pitch: 0,
              rotation: -15,
              viewMode: "3D", //开启3D视图,默认为关闭
              buildingAnimation: true, //楼块出现是否带动画
              mapStyle: "amap://styles/fresh", //设置地图的显示样式
              expandZoomRange: true,
            });
            // 创建一个 Marker 实例：
            var marker = new AMap.Marker({
              position: new AMap.LngLat(120.021808,30.286848), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: "杭开集团",
            });

            // 将创建的点标记添加到已有的地图实例：
            map.add(marker);
          })
          .catch((e) => {
            console.log(e);
          });
      }, 800);
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/contactUs.php";

      this.axios
        .get(url)
        .then((res) => {
          this.hkjt = res.data;
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
};
</script>

<style>
#mapContent {
  width: 93.75rem;
  height: 30rem;
}

.contentUs-company-content > ul {
  /* white-space: nowrap; */
}

.contentUs-content-details-list > * {
  font-size: 0.875rem !important;
}

.contactUs-content-text {
  font-size: 0.875rem;
  line-height: 1.8rem;
}

.contentUs-company-name {
  font-size: 1.25rem;
}

.contactUs-content-title > h4 {
  font-size: 1.125rem;
  color: rgb(54, 54, 54);
}

.contentUs-map-box {
  /* height: 23.5rem; */
  margin-bottom: 7rem !important;
}

.contentUs-company-box {
  width: 93.75rem;
}

.contentUs-map-img {
  width: 93.75rem;
}

.contentUs-company-link-box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.contentUs-company-link {
  display: block;
  background-color: #237fef;
  color: #fff;
  text-decoration: none;
  height: 2.5rem;
  width: 8rem;
  line-height: 2.5rem;
}

.contentUs-company-link:hover {
  color: #fff;
  background-color: #237fefbe;
}

.contactUs-img {
  width: 100vw;
}

.contactUs-content-img {
  height: 26rem;
  position: relative;
  left: -25%;
}

.contactUs-content-box {
  margin: 7rem 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.contactUs-content-box > div {
  margin: 2rem auto;
}

.contactUs-content-img-box {
  width: 26rem;
  overflow: hidden;
  border-radius: 0.375rem;
  flex: 0 0 auto;
}

.contactUs-top-box {
  width: 93.75rem;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.contactUs-content-text-list {
  height: 90%;
  padding: 3rem 2rem;
  border: 1px solid #98989893;
  border-left-style: none;
  margin-bottom: 0;
}

.contactUs-content-text-list > li {
  margin-bottom: 2.2rem;
}

.contactUs-content-text {
  color: #989899;
}

.contentUs-content-details-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.contentUs-content-details-list > li {
  width: 50%;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
}

.contentUs-content-details-title {
  text-align-last: justify;
  width: 4rem;
}

.contentUs-company-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.contentUs-company-item {
  border: 1px solid #e0e0e0;
  text-align: center;
  border-radius: 0.625rem;
  width: 28%;
  padding: 3rem 1rem;
  /* margin: 0 3.75rem 3.75rem 0; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 3.75rem;
}

.contentUs-company-item:hover {
  box-shadow: 0 10px 10px 0 rgb(110 131 198 / 10%);
}

.contentUs-company-content {
  width: auto;
  border-top: 1px solid #e0e0e0;
  padding: 1.5rem 0.5rem 1.5rem 0;
}

.contentUs-company-content > ul {
  font-size: 1.3rem;
  margin: 0.5rem auto;
  text-align: left;
  line-height: 2.5rem;
  font-size: 1.2rem;
  padding-left: 0.7rem;
}

.contentUs-company-img-box {
  width: 100%;
  text-align: center;
}

.contentUs-company-img {
  width: 18.8625rem;
  margin: 0 auto;
  margin-bottom: 2rem;
}

.list-address{
  white-space: pre-wrap;
}

@media screen and (max-width: 1705px) {
  .contentUs-company-item {
    width: 45%;
  }
}

@media screen and (max-width: 1555px) {
  .contentUs-company-box,
  .contentUs-map-img,
  .contactUs-top-box,
  #mapContent {
    width: 75rem;
  }

  .contentUs-map-box {
    margin-bottom: 2rem !important;
  }
}

@media screen and (max-width: 1270px) {
  .contentUs-company-box,
  .contentUs-map-img,
  .contactUs-top-box,
  #mapContent {
    width: 95%;
  }

  .contentUs-map-box {
    display: flex;
    justify-content: center;
  }

  .contactUs-content-text-list {
    padding: 2rem 1rem 0 1rem;
  }
}

@media screen and (max-width: 1080px) {
  .contactUs-top-box {
    flex-direction: column;
    border: 1px solid #98989893;
    border-radius: 0.5rem;
  }

  .contactUs-content-title {
    text-align: center;
  }

  .contactUs-content-img-box {
    width: 25%;
    height: 25%;
    margin: 0 auto;
  }

  .contactUs-content-img {
    height: 25%;
  }

  .contactUs-content-text-list {
    border: 0;
  }
}

@media screen and (max-width: 991px) {
  .contentUs-company-content > ul {
    /* white-space: normal; */
    margin: 0;
  }

  .contactUs-content-img {
    margin-top: 1rem;
  }

  .contactUs-content-box {
    margin: 1rem 0;
  }

  .contactUs-img {
    margin-top: 0.5rem;
  }

  .contentUs-company-list {
    flex-direction: column;
  }

  .contentUs-company-item {
    width: 100%;
    height: 35rem;
  }

  .contentUs-company-img-box {
    width: 30%;
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .contentUs-company-img {
    width: 100%;
  }

  .contentUs-company-item {
    flex-direction: row;
    justify-content: space-between;
  }

  .contentUs-company-content {
    border: 0;
  }

  .contentUs-company-link-box {
    height: auto;
  }

  .contentUs-company-content-body-box {
    width: 70%;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .contentUs-company-content {
    margin: auto 0;
  }

  .contentUs-company-name {
    font-size: 2rem;
  }

  .contactUs-content-img-box {
    width: 100%;
    height: auto;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .contactUs-content-img {
    position: static;
    border-radius: 0.5rem;
  }
}

@media screen and (max-width: 540px) {
  #mapContent {
    height: 28rem;
  }

  .contentUs-company-name {
    font-size: 1rem;
  }

  .contentUs-company-content > ul {
    font-size: 0.8rem;
  }

  .contentUs-company-item {
    padding: 0 0 1rem 0;
    min-height: 21rem;
    max-height: 25rem;
  }

  .contentUs-content-details-list > li {
    font-size: 0.2rem;
  }
}
</style>